const getTheme = (totalLines) => ({
  baseStyle: {
    pl: 0,
    pr: 0,
    borderBottomColor: "gray.300",
    _focus: {
      borderBottomColor: "primary.500",
      shadowColor: "primary.500",
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 1,
      shadowRadius: 0,
      elevation: 1,
    }
  },
  defaultProps: {
    totalLines,
    isFullWidth: true,
    colorScheme: "primary",
    variant: "underlined",
  },
  variants: {
    rounded: {
      pl: 3,
      pr: 3,
    },
    readOnly: ({}) => {
      return {
        borderWidth: 0,
        borderBottomWidth: 1,
        borderBottomColor: "rgba(0,0,0,0)",
        _focus: { borderBottomColor: "rgba(0,0,0,0)", },
        pl: 0,
        pr: 0,
      };
    },
  }
})

export const InputTheme = {
  Input: getTheme(),
  TextArea: getTheme(2),
}